import * as React from "react";
import { stringify } from "querystring";
import { ChangeEvent, ChangeEventHandler, useEffect, useState } from "react";
import API from "../Api";
import { useSession } from "../session/Context";
import { toast } from "react-toastify";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

export default function CreateTemplate() {
  const { brand, is_admin } = useSession();

  const [schemas, setSchemas] = useState<any[]>([]);
  const [types, setTypes] = useState<any[]>([]);

  const [data, setData] = useState<any>({
    name: "",
    schema: "",
    type: "",
    types: "",
    credential_subject: "",
    order: "",
  });

  const setPartialData = (e: ChangeEvent<any>) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  useEffect(() => {
    Promise.all([
      API("/api/v1/schema?type=metadata"),
      API("/api/v1/factories?type=types"),
    ]).then((values) => {
      let defaultSchema = "";
      let defaultType = "";
      setSchemas(
        Object.keys(values[0]).map((id) => {
          if (defaultSchema === "") {
            defaultSchema = id;
            setData({ ...data, schema: id });
          }
          return {
            label: values[0][id].name,
            value: id,
            tooltip: values[0][id].desc,
          };
        })
      );
      setTypes(
        Object.keys(values[1]).map((id) => {
          if (defaultType === "") {
            defaultType = id;
            setData({ ...data, type: id });
          }
          return { label: values[1][id], value: id };
        })
      );
    });
  }, []);

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    let body = {
      ...data,
      type: data.type.value,
      credential_subject: JSON.parse(data.credential_subject),
      types: data.types.split(","),
      order: data.order !== "" ? data.order.split(",") : undefined,
      schema: window.location.origin + "/api/v1/schema?id=" + data.schema.value,
    };
    API("/api/v1/factories", {
      method: "POST",
      body: JSON.stringify(body),
    })
      .then((resp) => {
        toast.success(resp);
      })
      .catch((e) => toast.error(e));
  };

  const handleChangeSchema = (event: SelectChangeEvent) => {
    setData({
      ...data,
      schema: schemas.find((val) => event.target.value === val.value),
    });
  };

  const handleChangeType = (event: SelectChangeEvent) => {
    setData({
      ...data,
      type: types.find((val) => event.target.value === val.value),
    });
  };

  return (
    <>
      <div className="mobile-pro">
        <h1>Create new template</h1>
      </div>

      <div className="col-content">
        <div className="notifications-container">
          <div className="messages m-hide">
            <p className="light">Templates</p>
            <h2>Create new template</h2>
          </div>

          <form onSubmit={onSubmit} className="form">
            <div className="add_issuance__cards">
              <div className="cards">
                <label>Unique name:</label>
                <input
                  required
                  name="name"
                  type="text"
                  value={data.name}
                  onChange={setPartialData}
                  className="template-field"
                ></input>

                <label>Schema:</label>

                <Select
                  required
                  className="template-field"
                  value={
                    data.schema == ""
                      ? data.schema
                      : data.schema.hasOwnProperty("value")
                      ? data.schema.value
                      : ""
                  }
                  onChange={handleChangeSchema}
                >
                  <MenuItem disabled value="">
                    <em>Select schema</em>
                  </MenuItem>
                  {schemas ? (
                    schemas.map((item) => {
                      return (
                        <MenuItem
                          selected={schemas[0].value === item.value}
                          key={item.value}
                          value={item.value}
                        >
                          {item.label}
                        </MenuItem>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </Select>

                <label>Types:</label>
                <Select
                  required
                  className="template-field"
                  value={
                    data.type == ""
                      ? data.type
                      : data.type.hasOwnProperty("value")
                      ? data.type.value
                      : ""
                  }
                  onChange={handleChangeType}
                >
                  <MenuItem disabled value="">
                    <em>Select type</em>
                  </MenuItem>

                  {types ? (
                    types.map((item) => {
                      return (
                        <MenuItem
                          selected={types[0].value === item.value}
                          key={item.value}
                          value={item.value}
                        >
                          {item.label}
                        </MenuItem>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </Select>

                <label>Credential types:</label>
                <input
                  required
                  className="template-field"
                  name="types"
                  type="text"
                  value={data.types}
                  onChange={setPartialData}
                ></input>

                <label>Credential subjects:</label>
                <textarea
                  required
                  className="template-field"
                  name="credential_subject"
                  value={data.credential_subject}
                  onChange={setPartialData}
                ></textarea>

                <label>Order of subjects:</label>
                <input
                  className="template-field"
                  name="order"
                  type="text"
                  value={data.order}
                  onChange={setPartialData}
                ></input>
              </div>
            </div>

            <button
              className="btn btn-primary issuance__btn"
              type="submit"
              value="Add"
            >
              Add
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
